
// This file exports available shaders to the GUI.
// follow this syntax to make your shaders available to the GUI
export {default as Lambert} from './lambert'

export {default as Toon} from './toon'


// WEBPACK FOOTER //
// ./src/shaders/index.js